import { EmbedReportModel, embedReportModelInitial } from './EmbedReportModel';
import { EmbedTokenModel, embedTokenModelInitial } from './EmbedTokenModel';

export interface EmbedParamsModel {
    type: string,
    embedReport: EmbedReportModel,
    embedToken: EmbedTokenModel,
}

export const embedParamsModelInitial: EmbedParamsModel = {
    type: '',
    embedReport: embedReportModelInitial,
    embedToken: embedTokenModelInitial,
};